import { GoldDivider, Eyebrow, EditorialHeading } from "../brand";

export default function SectionHeader({ eyebrow, title, subtitle, align = "left", size = "lg", className = "" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
      {eyebrow && <Eyebrow className={align === "center" ? "mx-auto" : ""}>{eyebrow}</Eyebrow>}
      <EditorialHeading size={size} className="mt-4">{title}</EditorialHeading>
      {subtitle && <p className="mt-6 text-base sm:text-lg text-altura-charcoal/70 leading-relaxed">{subtitle}</p>}
      <GoldDivider className={`mt-8 ${align === "center" ? "mx-auto" : ""}`} />
    </div>
  );
}
